import moment from "moment";
import {toast} from "react-toastify";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { clearPersistedCache, queryClient } from "../queries";
import { store, logout } from "../store";

export const onLogout = value => {
  localStorage.removeItem("doctolikLoginInfo");
  localStorage.removeItem("isAciveDoctorAcc");
  Cookies.remove("doctolikAuthToken");
  clearPersistedCache(queryClient);
  try {
    store.dispatch(logout());
  } catch (e) {
    console.warn('[Logout] Failed to dispatch Redux logout:', e);
  }
  if (value === "notshow") {
  } else {
    toast.success("Logout successfully", {autoClose: 1500});
  }
};

export const logInDetails = () => {
  let value = JSON.parse(localStorage.getItem("doctolikLoginInfo"));
  return value;
};

export const isPreviousDateFromCurrent = date => {
  // If no date is provided, use the current date
  const inputDate = date || moment().format("YYYY-MM-DD"); // Use 'YYYY' instead of 'yyyy'

  const isPast = moment(inputDate).isBefore(moment(), "day"); // Compare only by day

  return isPast;
};

export const chatMessgaeDateFormat = date => {
  const itemDate = moment(date);
  const currentDate = moment();

  const isToday = itemDate.isSame(currentDate, "day");

  const displayDate = isToday ? `Today at ${itemDate.format("HH:mm")}` : itemDate.format("ddd D, YYYY");

  return displayDate;
};

export const getFileExtension = fileName => {
  return fileName.split(".").pop(); // Gets the last part after the last dot
};

export const getQueryParams = () => {
  return new URLSearchParams(location.search);
};

export const formatDateInDayDateYear = date => {
  const itemDate = moment(date);

  const displayDate = itemDate.format("ddd D, YYYY");

  return displayDate;
};

export const daysDifferenceFunction = fromDate => {
  // Use Moment.js to parse the created_at date
  const createdDate = moment(fromDate);
  const currentDate = moment();

  // Calculate the difference in days
  const daysDifference = currentDate.diff(createdDate, "days");

  return daysDifference;
};

export const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return; // Click is inside the element, do nothing.
      }
      handler(); // Click is outside, call the handler.
    };

    document.addEventListener("mousedown", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
    };
  }, [ref, handler]);
};
